import { translateLoadedSource, useSourceLanguage } from "./LocalizedCopy";
import { useI18n } from "./LanguageContext";
import { NAVIGATION_LABEL_KEYS } from "./navigationTranslations";

export default function useNavigationTranslations() {
  const { t, lang } = useI18n();
  useSourceLanguage();
  const translate = typeof t === "function" ? t : (key, fallback) => fallback || key;
  const translateLabel = (label) => {
    const key = NAVIGATION_LABEL_KEYS[label];
    return key ? translate(key, label) : translateLoadedSource(label, lang);
  };
  const translateMessage = (key, fallback, values) => Object.entries(values).reduce(
    (message, [name, value]) => message.replace(`{${name}}`, String(value)),
    translate(key, fallback)
  );
  return { translate, translateLabel, translateMessage };
}
